import LangEnum from '../../../lang/LangEnum';
import PATHS from '../../../routes/routes.const';
import { useRachelPageNavigation } from '../../rachel/hooks/useRachelPageNavigation';
import { useRachelSubmit } from '../../rachel/hooks/useRachelSubmit';
import { getRachelPageEntity } from '../../rachel/rachelPageContext.utils';
import { useTranslation } from '../../translation/TranslationContext';

interface UseAskRachelParams {
  term: string;
  activeEntityLabel: string;
  onClose: () => void;
}

const useAskRachel = ({ term, activeEntityLabel, onClose }: UseAskRachelParams) => {
  const { translate } = useTranslation();
  const { submit } = useRachelSubmit({
    shouldStartNewChat: true,
    pageContext: {
      pathname: PATHS.main.rachel.path,
      ...getRachelPageEntity(PATHS.main.rachel.path),
      label: translate(PATHS.main.rachel.pageTitleKey),
      focusedEntity: null,
      focusedEntityId: null,
    },
  });
  const { openPage } = useRachelPageNavigation();

  const trimmedTerm = term.trim();
  const canAsk = Boolean(trimmedTerm);

  const ask = () => {
    if (!canAsk) {
      return;
    }

    const message = activeEntityLabel
      ? translate(LangEnum.GLOBAL_SEARCH_ASK_RACHEL_PROMPT_IN_ENTITY, {
          term: trimmedTerm,
          entity: activeEntityLabel,
        })
      : translate(LangEnum.GLOBAL_SEARCH_ASK_RACHEL_PROMPT, { term: trimmedTerm });

    onClose();
    openPage();
    void submit(message);
  };

  return { canAsk, ask };
};

export default useAskRachel;
